import React from "react"

export const BarProgress: React.FC = () => {
  return (
    <svg
      width="11"
      height="7"
      viewBox="0 0 11 7"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.875 1.375V5.5H9.625V1.375H6.875ZM0 1.375C0 0.623047 0.623047 0 1.375 0H9.625C10.377 0 11 0.623047 11 1.375V5.5C11 6.25195 10.377 6.875 9.625 6.875H1.375C0.623047 6.875 0 6.25195 0 5.5V1.375Z"
        fill="#5E7A88"
      />
    </svg>
  )
}
